/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardActivityDto { 
    type?: DashboardActivityDto.TypeEnum;
    userEmail?: string;
    points?: number;
    couponName?: string;
    loyaltyProgramName?: string;
    amount?: number;
    timestamp?: string;
}
export namespace DashboardActivityDto {
    export type TypeEnum = 'TRANSACTION_APPROVED' | 'TRANSACTION_PENDING' | 'COUPON_REDEEMED' | 'MEMBER_JOINED';
    export const TypeEnum = {
        TransactionApproved: 'TRANSACTION_APPROVED' as TypeEnum,
        TransactionPending: 'TRANSACTION_PENDING' as TypeEnum,
        CouponRedeemed: 'COUPON_REDEEMED' as TypeEnum,
        MemberJoined: 'MEMBER_JOINED' as TypeEnum
    };
}


